exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu-item-row {\n  height: 37vw;\n  max-height: 160px;\n}\n@media screen and (max-width: 280px) {\n  .menu-item-row {\n    height: 42vw;\n    max-height: 165px;\n  }\n}\n.menu-item-row .menu-item-row-content {\n  height: 100%;\n}\n.menu-item-row .item-detail {\n  flex: 1 0 150px;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n.user-thumbnail {\n  object-fit: cover;\n  width: 27vw;\n  height: 27vw;\n  max-width: 150px;\n  max-height: 150px;\n  flex: 0 0 40px;\n  border-radius: 10px;\n}\n\n.badge.badge-orange-override {\n  background-color: orange !important;\n}", ""]);

// exports
